import { tracked } from "@glimmer/tracking";
import { task } from "ember-concurrency";
import Component from "@glimmer/component";
import { service } from "@ember/service";
import ENV from "glesys-controlpanel/config/environment";

export default class ModalsPrivateNetworkCreate extends Component {
  @service modal;
  @service http;
  @service current;
  @service abilities;

  @tracked name;
  @tracked billing;

  get task() {
    return this.args.params.task;
  }

  onChange = ({ name }) => (this.name = name);

  loadCostTask = task(async () => {
    if (this.abilities.cannot("access pricing for organization", this.current.project.organization)) {
      return;
    }

    this.billing = await this.http.request({
      url: `${ENV.apiBaseUri}/privatenetwork/estimatedcost`,
      method: "POST",
      body: {
        projectkey: this.current.project.id,
      },
    });
  });

  submitTask = task(async () => {
    let task = this.task;

    await task.perform(this.name);

    this.modal.close();
  });
}
